import React, { useState, useCallback, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { Text } from 'rebass'

import { ButtonYellowLight } from '../Button'
import { Card } from '../bakery/styleds'
import Value from '../Value/OnlyValue'
import { AutoRow } from '../Row'
import Loader from '../Loader'

import { useActiveWeb3React } from '../../hooks'
import useAllNtfEarnings from '../../hooks/nft/useAllNtfEarnings'
import useStakingPower from '../../hooks/nft/useStakingPower'
import useHarvestDish from '../../hooks/nft/useHarvestDish'
import useUnstakeBulk from '../../hooks/nft/useUnstakeBulk'
import { NFTTYPE } from '../../constants/bakery/nft'

const CardWrapper = styled.div`
  display: flex;
  font-family: Roboto-Medium;
  width: 620px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: column;
    align-items: center;
    width: auto;
  `}
`
const StakeCard = styled(Card)`
  display: flex;
  align-items: center;
  flex: 1;
  color: ${({ theme }) => theme.primary1};
  text-align: center;
  border: 1px solid rgba(255, 205, 132, 0.5);
  border-radius: 8px;
  background-color: initial;

  &:first-child {
    margin-right: 16px;
  }

  ${({ theme }) => theme.mediaWidth.upToMedium`
    &:first-child {
      margin: 0 0 16px 0;
    }
  `}
`
const AmountText = styled.div`
  background: linear-gradient(305.04deg, #FFD600 -43.12%, #FF7A00 70.33%);
  -webkit-background-clip: text;
  color: transparent;
  margin: 5px 0 17px;
  font-family: 'Roboto-Bold';
`
const ButtonRow = styled(ButtonYellowLight)`
  width: 104px;
  height: 28px;
  padding: 0 26px;
  margin-top: 17px;
  font-size: 14px;
  margin: 0 auto;
`
const RightDiv = styled.div`
  text-align: left;
`

export default function StakeRow ({type}: {type: string}) {
  const { account } = useActiveWeb3React()
  const theme = useContext(ThemeContext)
  const sumEarning = useAllNtfEarnings(type)
  const sumEarningV2 = useAllNtfEarnings(type + "_V2")
  const stakingPower = useStakingPower(type)
  const stakingPowerV2 = useStakingPower(type + "_V2")
  // harvest
  const onHarvestDish = useHarvestDish(type)
  const onHarvestDishV2 = useHarvestDish(type + "_V2")

  const [requestedHarvest, setRequestedHarvest] = useState(false)
  const handleHarvest = useCallback(async () => {
    try {
      setRequestedHarvest(true)
      let txHash:any = true
      let txHashV2:any = true
      if([
        NFTTYPE.DOGGIES,
        NFTTYPE.BARKING,
        NFTTYPE.EQUIPMENT,
        NFTTYPE.BAKEMUSKMIXER,
        NFTTYPE.CAR,
        NFTTYPE.COMBO,
        NFTTYPE.SOCCER,
        NFTTYPE.POKER,
      ].includes(type)){
        if(stakingPower.toNumber() && stakingPowerV2.toNumber()){
          const harvestArray = [onHarvestDish, onHarvestDishV2]
          harvestArray.map(async(d, index) => {
            if(index === 0){
              txHash = await d()
            }else{
              txHashV2 = await d()
            }
            if (!txHash && !txHashV2) {
              setRequestedHarvest(false)
            } else {
              setTimeout(() => {
                setRequestedHarvest(false)
              }, 15000)
            }
          })
        }else if(stakingPowerV2.toNumber() * 1){
          txHash = await onHarvestDishV2()
          txHashV2 = false
        }else{
          txHash = await onHarvestDish()
          txHashV2 = false
        }
      }else{
        txHash = await onHarvestDish()
        txHashV2 = false
      }
      if (!txHash && !txHashV2) {
        setRequestedHarvest(false)
      } else {
        setTimeout(() => {
          setRequestedHarvest(false)
        }, 15000)
      }
    } catch (e) {
      setRequestedHarvest(false)
      console.log(e)
    }
  }, [onHarvestDish, onHarvestDishV2, type, stakingPower, stakingPowerV2])

  // unstake all
  const onUnstakeBulk = useUnstakeBulk(type)
  const onUnstakeBulkV2 = useUnstakeBulk(type + "_V2")
  const [requestedUnstakeBulk, setRequestedUnstakeBulk] = useState(false)
  const handleUnstakeBulk = useCallback(async () => {
    try {
      setRequestedUnstakeBulk(true)
      let txHash:any = true
      let txHashV2:any = true
      if([
        NFTTYPE.DOGGIES,
        NFTTYPE.BARKING,
        NFTTYPE.EQUIPMENT,
        NFTTYPE.BAKEMUSKMIXER,
        NFTTYPE.CAR,
        NFTTYPE.COMBO,
        NFTTYPE.SOCCER,
        NFTTYPE.POKER,
      ].includes(type)){
        if(stakingPower.toNumber() && stakingPowerV2.toNumber()){
          const unstakeArray = [onUnstakeBulk, onUnstakeBulkV2]
          unstakeArray.map(async(d) => {
            txHash = await d()
            setTimeout(() => {
              txHashV2 = false
            }, 15000)
          })
        }else if(stakingPowerV2.toNumber() * 1){
          txHash = await onUnstakeBulkV2()
          txHashV2 = false
        }else{
          txHash = await onUnstakeBulk()
          txHashV2 = false
        }
      }else{
        txHash = await onUnstakeBulk()
        txHashV2 = false
      }
      if (!txHash && !txHashV2) {
        setRequestedUnstakeBulk(false)
      } else {
        setTimeout(() => {
          setRequestedUnstakeBulk(false)
        }, 15000)
      }
    } catch (e) {
      setRequestedUnstakeBulk(false)
      console.log(e)
    }
  }, [onUnstakeBulk, onUnstakeBulkV2, type, stakingPower, stakingPowerV2])

  return (
    <CardWrapper>
      <StakeCard>
        <img src="/images/collection/stake.svg" alt=""/>
        <RightDiv>
          <Text fontSize={14} color={theme.bsBg17}>{[NFTTYPE.GAMEBOX].includes(type) ? 'TLM' : 'BAKE'} Earned</Text>
          <AmountText>
            <Text fontSize={26}>
              {
                [
                  NFTTYPE.DOGGIES,
                  NFTTYPE.BARKING,
                  NFTTYPE.EQUIPMENT,
                  NFTTYPE.BAKEMUSKMIXER,
                  NFTTYPE.CAR,
                  NFTTYPE.COMBO,
                  NFTTYPE.SOCCER,
                  NFTTYPE.POKER,
                ].includes(type) ? (
                  <Value decimals={3} value={sumEarning.toNumber() + sumEarningV2.toNumber()} />
                ) : (
                  <Value decimals={3} value={sumEarning.toNumber()} />
                )
              }
            </Text>
          </AmountText>
          <ButtonRow
            onClick={handleHarvest}
            disabled={!account || (sumEarning.lte(0) && sumEarningV2.lte(0)) || requestedHarvest}
          >
            {requestedHarvest ? (
              <AutoRow gap="6px" justify="center">
                Collecting <Loader stroke="white" />
              </AutoRow>
            ) : (
              'Harvest'
            )}
          </ButtonRow>
        </RightDiv>
      </StakeCard>
      <StakeCard>
        <img src="/images/collection/unstake.svg" alt=""/>
        <RightDiv>
          <Text fontSize={14} color={theme.bsBg17}>Staking Power</Text>
          <AmountText>
            <Text fontSize={26}>
              {
                [
                  NFTTYPE.DOGGIES,
                  NFTTYPE.BARKING,
                  NFTTYPE.EQUIPMENT,
                  NFTTYPE.BAKEMUSKMIXER,
                  NFTTYPE.CAR,
                  NFTTYPE.COMBO,
                  NFTTYPE.SOCCER,
                  NFTTYPE.POKER,
                ].includes(type) ? (
                  <Value decimals={3} value={stakingPower.toNumber() + stakingPowerV2.toNumber()} />
                ) : (
                  <Value decimals={3} value={stakingPower.toNumber()} />
                )
              }
            </Text>
          </AmountText>
          <ButtonRow
            onClick={handleUnstakeBulk}
            disabled={requestedUnstakeBulk || (stakingPower.lte(0) && stakingPowerV2.lte(0))}
          >
            {requestedUnstakeBulk ? (
              <AutoRow gap="6px" justify="center">
                Unstaking <Loader stroke="white" />
              </AutoRow>
            ) : (
              'Unstake'
            )}
          </ButtonRow>
        </RightDiv>
      </StakeCard>
    </CardWrapper>
  )
}